var render = function render(){var _vm=this,_c=_vm._self._c;return (this.THEME === 'ACLARS')?_c('ACLARSLogo'):(this.THEME === 'ICLRS')?_c('ICLRSLogo'):(this.THEME === 'UAE')?_c('UAELogo'):(this.THEME === 'India')?_c('IndiaLogo'):(this.THEME === 'Ethiopia')?_c('EthiopiaLogo'):_c('ICLRSLogo')
}
var staticRenderFns = []

export { render, staticRenderFns }